
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA en Bretagne dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads en Bretagne certifiée Google Partner, accompagne les entreprises bretonnes pour accroître leur visibilité en ligne et attirer des prospects qualifiés.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads en Bretagne dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads en Bretagne certifiée Google Partner, accompagne les entreprises bretonnes pour accroître leur visibilité en ligne et attirer des prospects qualifiés.",
        },
      ],
    };
  },
};
